import { IStyle } from '@fluentui/react';
import { CommonStyles } from '@h2oai/ui-kit';

export interface IRetrieveDownloadStyles {
  root?: IStyle;
  body?: IStyle;
  downloadLinks?: IStyle;
  downloadLink?: IStyle;
  downloadLinksContent?: IStyle;
  downloadLinksBody?: IStyle;
  buttons?: IStyle;
}

export interface IRetrieveDownloadClassNames {
  root: string;
  body: string;
  downloadLinks: string;
  downloadLink: string;
  downloadLinksContent: string;
  downloadLinksBody: string;
  buttons: string;
}

export const retrieveDownloadStylesDefault: Partial<IRetrieveDownloadStyles> = {
  root: {
    flex: 1,
    display: 'flex',
    height: '100%',
    paddingTop: 17,
    flexDirection: 'column',
    minHeight: 0,
  },
  body: {
    flex: 1,
  },
  downloadLinks: {
    minWidth: '300px',
  },
  downloadLink: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  downloadLinksContent: {
    display: 'flex',
    justifyContent: 'space-between',
    'div:first-child': {
      ...CommonStyles.flexCenterVertically,
    },
  },
  downloadLinksBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  buttons: { display: 'flex', gap: '8px', justifyContent: 'flex-end' },
};
